"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectContext = exports.defaultContext = exports.SelectProvider = exports.SelectContext = void 0;
var _react = require("react");
var _mockUtils = require("@cbhq/cds-common/utils/mockUtils");
const defaultContext = {
  onChange: _mockUtils.NoopFn,
  value: undefined,
  handleCloseMenu: undefined
};
exports.defaultContext = defaultContext;
const SelectContext = /*#__PURE__*/(0, _react.createContext)(defaultContext);
exports.SelectContext = SelectContext;
const SelectProvider = SelectContext.Provider;
exports.SelectProvider = SelectProvider;
const useSelectContext = () => (0, _react.useContext)(SelectContext);
exports.useSelectContext = useSelectContext;